import React from 'react';
import { Input } from 'antd';

const MeterInput = ({ onChange, className = '', ...rest }) => {
  return (
    <Input
      className={`h-16 w-16 mx-1 border text-center text-3xl border-primary ${className}`}
      onChange={(e) => {
        const regex = new RegExp(/^(?:\d{1}|)$/, 'g');
        if (regex.exec(e.target.value)) {
          onChange(e);
        }
      }}
      maxLength={1}
      {...rest}
    />
  );
};

export default MeterInput;
